import { render, staticRenderFns } from "./BoardListJstNoticeLayout.vue?vue&type=template&id=350cc1ba&scoped=true&"
import script from "./BoardListJstNoticeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListJstNoticeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350cc1ba",
  null
  
)

export default component.exports